import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Building2 } from "lucide-react";
import { CustomerCombobox } from "@/components/CustomerCombobox";
import { SerialNumberCombobox } from "@/components/SerialNumberCombobox";

export function ServiceReportCustomerDevice({
  customers,
  customerId,
  onCustomerChange,
  serialNumbers,
  serialNumberId,
  onSerialNumberChange,
}) {
  return (
    <Card>
      <CardHeader className="p-4 md:p-6">
        <CardTitle className="flex items-center gap-2 text-lg md:text-xl">
          <Building2 className="w-5 h-5" />
          Kunde & Gerät
        </CardTitle>
        <CardDescription className="text-sm">Wählen Sie den Kunden und optional ein Gerät</CardDescription>
      </CardHeader>
      <CardContent className="p-4 md:p-6 pt-0 md:pt-0 grid gap-4 md:gap-6 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="customer">Kunde *</Label>
          <CustomerCombobox
            customers={customers}
            value={customerId}
            onChange={onCustomerChange}
            placeholder="Kunde auswählen oder suchen..."
            testid="report-customer-combobox"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="serial">Seriennummer</Label>
          <SerialNumberCombobox
            serialNumbers={serialNumbers}
            value={serialNumberId}
            onChange={onSerialNumberChange}
            disabled={!customerId}
            emptyText={!customerId ? "Erst Kunde auswählen" : "Keine Geräte"}
            placeholder="Gerät auswählen..."
            testid="report-serial-combobox"
          />
        </div>
      </CardContent>
    </Card>
  );
}
